import "./utils/fetch";
import "./utils/polyfills";

import React from "react";
import { render } from "react-dom";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

import configureStore from "./configureStore";
import { getUrlParameter } from "./utils";
import App from "./App";

if (getUrlParameter("utm_source")) {
  cookie("utm_source", getUrlParameter("utm_source"), 30);
}

Bugsnag.start({
  apiKey: "922a79e84afed44d460371f8d3582691",
  appVersion: "1.0.6",
  plugins: [new BugsnagPluginReact()],
});

const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);

configureStore().then((store) => {
  // GA client ID
  gtag("get", "G-95KZ6YGSKT", "client_id", function (clientId) {
    store.dispatch({ type: "GA_CLIENT_ID", payload: clientId });
  });

  return render(
    <ErrorBoundary>
      <App store={store} />
    </ErrorBoundary>,
    document.getElementById("root")
  );
});
